function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 59.5,
  cy: 59.5,
  r: 59.5,
  fill: "#627EEA"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M59.894 16l-.633 2.11v58.034l.633.633 27.012-16.038L59.894 16z",
  fill: "#C0CCF7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M59.894 16L32.882 60.739l27.012 16.038V16z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M59.894 81.842l-.422.422v20.681l.422 1.055 27.012-37.986-27.012 15.828z",
  fill: "#C0CCF7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M59.894 104V81.842L32.882 66.014 59.894 104z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M59.895 76.777l27.011-16.038-27.012-12.24v28.278z",
  fill: "#8198EE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.882 60.739l27.012 16.038V48.499l-27.012 12.24z",
  fill: "#C0CCF7"
}));

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(16 16)",
  d: "M0 0h88v88H0z"
})));

function SvgEthereum(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 119,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthereum);
export default __webpack_public_path__ + "static/media/Ethereum.98250039.svg";
export { ForwardRef as ReactComponent };